import React from "react";
import { useNavigate } from "react-router-dom";
import { IconButton, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import deleteAccountInstructionConfig from "./DeleteAccountInstruction.config";
import "./DeleteAccountInstruction.style.css";

const DeleteAccountInstruction = () => {
  const navigate = useNavigate();
  const { pageTitle, sections } = deleteAccountInstructionConfig;

  return (
    <div className="delete-account-page">
      <header className="delete-account-header">
        {/* <IconButton
          type="button"
          className="delete-account-header-back"
          onClick={() => navigate("/")}
          aria-label="Back to home"
          size="small"
        >
          <ArrowBack fontSize="small" />
        </IconButton> */}

        <div className="delete-account-header-inner">
          <Typography
            component="h1"
            variant="h4"
            className="delete-account-page-title"
          >
            {pageTitle}
          </Typography>
        </div>
      </header>

      <main className="delete-account-body">
        {sections.map((section) => (
          <article
            key={section.id}
            className="delete-account-section"
            aria-labelledby={`delete-account-section-${section.id}`}
          >
            <Typography
              component="h2"
              id={`delete-account-section-${section.id}`}
              variant="subtitle1"
              className="delete-account-section-title"
            >
              {section.title}
            </Typography>

            {(section.paragraphs || []).map((content, index) => (
              <Typography
                key={`${section.id}-paragraph-${index}`}
                component="p"
                variant="body1"
                className="delete-account-paragraph"
              >
                {content}
              </Typography>
            ))}

            {section.orderedList?.length ? (
              <ol className="delete-account-list delete-account-list-ordered">
                {section.orderedList.map((item, index) => (
                  <li key={`${section.id}-ordered-${index}`}>{item}</li>
                ))}
              </ol>
            ) : null}

            {section.unorderedList?.length ? (
              <ul className="delete-account-list delete-account-list-unordered">
                {section.unorderedList.map((item, index) => (
                  <li key={`${section.id}-unordered-${index}`}>{item}</li>
                ))}
              </ul>
            ) : null}
          </article>
        ))}
      </main>
    </div>
  );
};

export default DeleteAccountInstruction;